import React, { useState } from 'react';

import UI from '#front-credpago';

import useResizer from '../../../utils/useResizer';
import * as S from './styles';

const History = () => {
  const isMobile = useResizer();
  const [currentTimeline, setCurrentTimeline] = useState(1);

  const initialTimelineList = [
    {
      year: 2016,
      descriptions: [
        {
          title: 'Pioneiros em garantia para aluguel com uso do cartão de crédito.',
          text: 'Nascemos para revolucionar o mercado imobiliário.',
        },
        {
          title: 'Classificados para Startup SC do Sebrae de Santa Catarina.',
          text: 'Dentre 261 participantes, fomos selecionados para o Programa de capacitação Startup SC.',
        },
      ],
    },

    {
      year: 2017,
      descriptions: [
        {
          title: 'CredPago ganha um rosto e lança a primeira ferramenta.',
          text: 'Chegada do sócio Bruno Gagliasso e do primeiro Simulador de locações do mercado.',
        },
      ],
    },

    {
      year: 2018,
      descriptions: [
        {
          title: 'Crescimento exponencial em território nacional.',
          text: 'Número de clientes aumentou em 290% e imobiliárias parceiras em mais de 200%.',
        },
      ],
    },

    {
      year: 2019,
      descriptions: [
        {
          title: 'Aceleração dos nossos negócios em dose dupla.',
          text: 'Duas vezes selecionados pela Endeavor para os programas Scale-Up e Scale-Up Fintech.',
        },

        {
          title: 'Análise de crédito de número 100 mil.',
          text: 'Neste ano alcançamos a marca de cem mil análises feitas.',
        },

        {
          title: 'Estreia da CredPago no Conecta Imobi.',
          text: 'Primeira participação como patrocinadores oficiais do maior evento imobiliário da américa.',
        },

        {
          title: 'Marca reconhecida em nível nacional.',
          text: 'Escolhidos pela revista PEGN como uma das 100 Startups mais promissoras do país.',
        },

        {
          title: 'Nova sede CredPago Curitiba.',
          text: 'Com o aumento expressivo da equipe inauguramos uma sede maior.',
        },
      ],
    },

    {
      year: 2020,
      descriptions: [
        {
          title: 'Atingimos o contrato de número 100 mil.',
          text: 'Mesma diante da pandemia, nosso crescimento continuou exponencial.',
        },

        {
          title: 'Criação da matriz CredPago Joinville.',
          text: 'Com o aumento expressivo da equipe inauguramos a filial em Santa Catarina.',
        },

        {
          title: 'Aliamos a nossa tecnologia a solidez de um banco.',
          text: 'Chegada do BTG Pactual para reforçar nossos negócios.',
        },

        {
          title:
            'Conquistamos o selo RA 1000 no site Reclame Aqui, que nos identifica como uma empresa excelente no atendimento humanizado.',
          text: '',
        },
      ],
    },

    {
      year: 2021,
      descriptions: [
        {
          title: 'Alcançamos a liderança em emissão de garantias locatícias residenciais no Brasil.',
          text: `+ 750 mil pessoas impactadas com nossa garantia de aluguel
          + 50 mil solicitações/mês de assinaturas eletrônicas (CredSign)
          + de 700 municípios operando CredPago
          + de 16 mil imobiliárias parceiras
          `,
        },

        {
          title:
            'CredPago é vendida ao Grupo Loft, startup especializada na compra, reforma e venda de apartamentos que está no topo da lista dos maiores unicórnios do Brasil.',
          text: '',
        },
      ],
    },
  ];

  const [timeline, setTimeline] = useState(initialTimelineList);

  const handleChangeTimeline = () => {
    if (currentTimeline === 1) {
      setCurrentTimeline(2);
    } else {
      setCurrentTimeline(1);
      setTimeline(initialTimelineList);
    }
  };

  return (
    <S.Container>
      <S.WrapperTitle>
        <UI.Title level={2} fontWeight={700} splitLabel={['Um pouco da', '']} />
        <UI.Title level={2} fontWeight={700} splitLabel={['', 'nossa história']} />
      </S.WrapperTitle>

      {isMobile ? (
        <S.WrapperDescription>
          <UI.Description color="gray" style={{ textAlign: 'center' }}>
            Chegamos em 2016 rompendo barreiras no mercado de locação de imóveis, diminuindo custos e eliminando
            processos burocráticos. Baixamos a régua de preços das garantias pagas, o que trouxe mais liberdade para
            quem quer alugar sem precisar de fiador.
          </UI.Description>
        </S.WrapperDescription>
      ) : (
        <S.WrapperTimeline>
          <S.NextBtn
            type="left"
            onClick={currentTimeline === 1 ? () => {} : handleChangeTimeline}
            disabled={currentTimeline === 1}
          >
            {/* &lsaquo; */}
          </S.NextBtn>

          {timeline.map((timeline, i) => (
            <S.Timeline key={i} showBorderLeft={i + 1 === 1}>
              <S.WrapperYear>
                <S.Year>{timeline.year}</S.Year>
                {['left', 'right'].map((type) => (
                  <S.PointYear key={type} type={type} />
                ))}
              </S.WrapperYear>
              <S.WrapperContent>
                {timeline.descriptions.map((description, index) => (
                  <S.Content key={index}>
                    <S.TitleTimeline>{description.title}</S.TitleTimeline>
                    <S.TextTimeline>{description.text}</S.TextTimeline>
                  </S.Content>
                ))}
              </S.WrapperContent>

              {['topLeft', 'topRight', 'bottomLeft', 'bottomRight'].map((type) => (
                <S.PointTimeline key={type} type={type} />
              ))}
            </S.Timeline>
          ))}

          <S.NextBtn
            type="right"
            onClick={currentTimeline === 2 ? () => {} : handleChangeTimeline}
            disabled={currentTimeline === 2}
          >
            {/* &rsaquo; */}
          </S.NextBtn>
        </S.WrapperTimeline>
      )}
    </S.Container>
  );
};

export default History;
